import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';
import { sortByProperty } from '../../../utils/utils';

const URL = 'payment-options-proxy?endpoint=paymentdashboard';

export const getPaymentMethods = createAsyncThunk(
  'methods',
  async (refreshData, { getState }) => {
    const listNotEmpty = getState().paymentOptions.methods.methodList.length;
    const pending =
      getState().paymentOptions.methods.methodListStatus === 'pending';

    if (pending || (!refreshData && listNotEmpty))
      return { methods: getState().paymentOptions.methods.methodList };

    const url = `${URL}/methods`;
    const response = await apiConfig.get(url).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

export const getMethodDetails = createAsyncThunk('methods/{id}', async (id) => {
  const url = `${URL}/methods/${id}`;
  const response = await apiConfig.get(url).catch((error) => {
    console.error(JSON.stringify(error));
    return error && error.response;
  });

  return response.data;
});

export const updateMethod = createAsyncThunk(
  'methods/{id}/update',
  async (payload) => {
    const url = `${URL}/methods/${payload.id}`;
    const response = await apiConfig.put(url, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

export const addNewMethod = createAsyncThunk(
  'methods/{id}/addNew',
  async (method) => {
    const url = `${URL}/methods`;
    const response = await apiConfig.post(url, method).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

const paymentOptionsMethodsSlice = createSlice({
  name: 'paymentOptionsMethods',
  initialState: {
    methodList: [],
    methodListStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed',
    selectedMethod: {},
  },
  reducers: {
    resetSelectedMethod(state) {
      state.selectedMethod = {};
    },
  },
  extraReducers: {
    [getPaymentMethods.pending]: (state) => {
      state.methodListStatus = 'loading';
    },
    [getPaymentMethods.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.methods) {
        state.methodListStatus = 'failed';
        state.methodList = [];
        return;
      }
      state.methodListStatus = 'succeeded';
      state.methodList = sortByProperty(action.payload.methods, 'methodName');
    },
    [getPaymentMethods.rejected]: (state) => {
      state.methodListStatus = 'rejected';
      state.methodList = [];
    },
    [getMethodDetails.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.methodId) {
        state.selectedMethod = {};
        return;
      }

      state.selectedMethod = action.payload;
    },
  },
});

export const selectMethodList = (state) =>
  state.paymentOptions.methods.methodList;
export const selectSelectedMethod = (state) =>
  state.paymentOptions.methods.selectedMethod;

export const paymentOptionsMethodsActions = paymentOptionsMethodsSlice.actions;

export default paymentOptionsMethodsSlice.reducer;
